// Freigabeliste der Dienste auf forge (docs/geheimnis-speicher.md, „Dienste
// auf forge“): welche Geheimnisse ein Dienst lesen darf, wozu, und ob sie
// hinterlegt sind -- NIE ein Wert. GET /v2-api/dienst/geheimnisse ist
// Hydration und Abgleich; ändert sich etwas im Geheimnis-Speicher, kommt
// das über den WS-Kanal "settings" (MutationBroadcast auf /v2-api/secrets),
// und die Liste lädt sofort neu. Die Einstellungs-Zeile „RunPod ·
// API-Schlüssel“ zeigt so „hinterlegt“, sobald das Formular gespeichert hat.

import { SvelteMap } from "svelte/reactivity";

import { loadPersisted, persist } from "./persistent-summary.svelte";
import { registerRevalidator } from "./revalidate.svelte";
import { onSettingsChange } from "./settings-live";

export interface DienstFreigabe {
  name: string;
  zweck: string;
  gesetzt: boolean;
}

const STORAGE_KEY = "dienst-geheimnisse";
// Ändern kann sich die Liste nur über den Geheimnis-Speicher (kommt per WS)
// oder ein Deploy -- der Abgleich ist nur das Netz unter dem Seil.
const ABGLEICH_MS = 300_000;

const _s = new SvelteMap<string, DienstFreigabe[]>();
let _started = false;

async function refresh(): Promise<void> {
  try {
    const r = await fetch("/v2-api/dienst/geheimnisse", { credentials: "include" });
    if (!r.ok) return;
    const l = (await r.json()) as DienstFreigabe[];
    if (!Array.isArray(l)) return;
    _s.set("current", l);
    persist(STORAGE_KEY, l);
  } catch {
    // Dienst startet neu -- der nächste Abgleich holt es nach.
  }
}

export function startDienstGeheimnisse(): void {
  if (_started) return;
  _started = true;
  // Darf mitten im Zeichnen gerufen werden (info() einer Einstellungs-
  // Zeile): in den Store erst danach schreiben, sonst bricht Svelte die
  // Seite ab (state_unsafe_mutation, wie ki-summary).
  queueMicrotask(() => {
    registerRevalidator(refresh);
    const cached = loadPersisted<DienstFreigabe[]>(STORAGE_KEY);
    if (Array.isArray(cached)) _s.set("current", cached);
    void refresh();
    setInterval(refresh, ABGLEICH_MS);
    onSettingsChange(["/v2-api/secrets"], refresh);
  });
}

/** Ist das Geheimnis hinterlegt? undefined, solange nichts geladen ist. */
export function dienstGeheimnisGesetzt(name: string): boolean | undefined {
  return _s.get("current")?.find((f) => f.name === name)?.gesetzt;
}
